/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom"
import { digitalWalletHead } from "../../../../../config/constant";
import { TableCell, TableRow } from "@mui/material";
import Typography from '@mui/material/Typography';
import { Image, Space, Col, Upload } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Button, TextField, Box } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import usePrevious from "../../../../Shared/components/Previous";
import { customAlaphabetValidation, emptyValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import { UploadOutlined } from '@ant-design/icons';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const ListTable = (props) => {

    const [visible, setVisible] = useState(false);
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const { details, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const [walletId, setWalletId] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [url, setUrl] = useState('');
    const [errorName, setErrorName] = useState(false);
    const [errorURL, setErrorURL] = useState(false);
    const dispatch = useDispatch();
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);


    const images = {
        beforeUpload: file => {
            setErrorMessage('');
            const isPNG = file.type === 'image/png';
            if (!isPNG) {
                setErrorMessage(`${file.name} is not a png file`);
            }
            return isPNG || Upload.LIST_IGNORE;
        },
        onChange: info => {
        },
    };


    const onEdit = (data) => {
        setVisible(true);
        setWalletId(data.id);
        setName(data.name);
        setDescription(data.description);
        setUrl(data.url);
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const emptyState = () => {
        setErrorName(false);
        setErrorURL(false);
    };

    const emptyStateInput = () => {
        setName('');
        setDescription('');
        setUrl('');
    };

    const editWallet = (e) => {
        e.preventDefault();
        let emptyname = customAlaphabetValidation('Wallet', name);
        let emptyURL = emptyValidation('URL', url);
        emptyState();
        if (emptyname.isValid && emptyURL.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'wallet',
                id: walletId,
                title: 'Wallet',
                details: {
                    name: name,
                    description: description,
                    url: url
                }
            });
        } else {
            if (emptyname.errors) {
                setErrorName(emptyname.errors);
            }
            if (emptyURL.errors) {
                setErrorURL(emptyURL.errors);
            }
        }
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setWalletId(data.id);
        setName(data.name);
    };

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'name') {
                setErrorName(error[1]);
            }
            if (error[0] === 'url') {
                setErrorURL(error[1]);
            }
        }
    }, [editDetails, editError, prevEditDetails, prevEditError]);


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={digitalWalletHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell style={{ width: getColumnWidth(digitalWalletHead, 0) }}><span style={{ width: getColumnWidth(digitalWalletHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(digitalWalletHead, 1) }}><span style={{ width: getColumnWidth(digitalWalletHead, 1) }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Digital Wallet', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Digital Wallet', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Digital Wallet'}</p>

                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Digital Wallet'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete='off'
                        onSubmit={(e) => editWallet(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Digital Wallet ", <span key={"Digital Wallet"} className={classes.colorRedRequired}> *</span>]}
                                variant='standard'
                                error={errorName ? true : false}
                                helperText={errorName}
                                value={name}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Description'
                                variant='standard'
                                value={description}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={["URL ", <span key={"URL"} className={classes.colorRedRequired}> *</span>]}
                                variant='standard'
                                error={errorURL ? true : false}
                                helperText={errorURL}
                                value={url}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setUrl(e.target.value)}
                            />
                            <Col>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Created by</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}></Typography>
                            </Col>
                            <Col>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Created Date & Time</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}></Typography>
                            </Col>
                            <Col>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Last Modified by</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}></Typography>
                            </Col>
                            <Col>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Last Modified Date & Time</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}></Typography>
                            </Col>
                            <Col>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Logo Image</Typography>
                                <div className={clsx(classes.uploadButton, classes.margin10t)}>
                                    <label htmlFor="contained-button-file">
                                        <Upload {...images}
                                            maxCount={1}
                                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                            listType="picture"
                                        >
                                            <Button startIcon={<UploadOutlined />}>Load File</Button>
                                        </Upload>
                                    </label>
                                    <div className={clsx(classes.imgErrormsg)}>
                                        {
                                            errorMessage && errorMessage
                                        }
                                    </div>
                                </div>
                            </Col>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                >
                                    Update & Close
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={walletId} loadTasks={() => loadTasks()} name={name} url={'wallet'} title={'wallet'} visible={deleteModal} />
        </>
    )
}